export default __webpack_public_path__ + "static/media/regimg-path.42ffa936.png";